import React from 'react';
import PropTypes from 'prop-types';

const ElementSelection = ({
  label, name, value, onChange, options,
}) => (
  <div className="flex flex-wrap mx-3 w-full">
    <div className="flex flex-col w-full px-3 lg:mb-6">
      <label
        htmlFor={name}
        className="text-gray-400 text-sm mb-2"
      >
        {label}
        <span className="text-red-500">*</span>
      </label>
      <select
        id={name}
        value={value}
        onChange={onChange}
        className="relative border-2 border-gray-500 bg-gray-300 px-5 rounded-md text-sm text-gray-500 text-bold leading-tight focus:outline-none focus:bg-white"
      >
        {options.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  </div>
);

export default ElementSelection;

ElementSelection.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};
